import { createClient } from '@supabase/supabase-js';

// Supabase credentials come from environment (set in /app/frontend/.env)
// REACT_APP_SUPABASE_URL    - the project URL (https://<ref>.supabase.co)
// REACT_APP_SUPABASE_ANON_KEY - the public anon key (safe to ship to browser)
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

let supabaseInstance = null;

export const getSupabase = () => {
  if (supabaseInstance) return supabaseInstance;
  if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
    // Defer the throw until first use so the marketing site stays bootable
    // without Supabase env vars (workspace is a feature, not a hard dep).
    throw new Error(
      'Supabase env vars missing. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in /app/frontend/.env'
    );
  }
  supabaseInstance = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: {
      // Keep a persistent session on the browser - shared with the mobile app
      // identity once the user logs in here.
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storage: typeof window !== 'undefined' ? window.localStorage : undefined,
      storageKey: 'buildpilot.auth',
    },
  });
  return supabaseInstance;
};

export const isSupabaseConfigured = () =>
  Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);
